import React, { useEffect, useState } from 'react';
import productImg from '../../../images/product-image.jpg';
import mapImg from '../../../images/map-left.jpg';
import { useParams } from 'react-router-dom';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import moment from 'moment';
import { DATE_FORMAT } from '../../../_common/constant';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import { useDepreciationApi } from '../../../store/api/hooks/depreciationApiHook';
import { GoogleMap, LoadScript, Marker, useJsApiLoader } from '@react-google-maps/api';
import { showDate } from '../../../_common/functions';
import { MAP_KEY } from '../../../_config';
import Currency from '../../../components/currency';
import toast from "react-hot-toast";

interface GeneralProps {
  reloadKey: number;
}

const General: React.FC<GeneralProps> = ({ reloadKey }) => {
  /* const { isLoaded } = useJsApiLoader({
    id: 'asset-gen-map-script',
    googleMapsApiKey: MAP_KEY,
  }) */

  const params: any = useParams();
  const assetsAPI = useAssetsApi();
  const facilityApi: any = useFacilitiesApi();
  const sageApi = useSagesApi();
  const depreciationApi = useDepreciationApi();
  const [rowDetails, setRowdetails] = useState<any>(null)
  const [rowData, setrowData] = useState<any>(null)
  const [disposalData, setDisposalData] = useState<any>(null)
  const [sageFacilityName, setSageFacilityName] = useState<string>('')
  const defaultLatitude = 40.712776; // Example default latitude (New York)
  const defaultLongitude = -74.005974; // Example default longitude (New York)

  const getAllSageFacilities = () => {
    const payload = {
      facilityID: rowDetails?.sageFacilityIDForAccounting
    };
    sageApi.getSageFacilityList(
      payload,
      (resp: any) => {
        const options = resp.facilityList;
        if (options && options.length > 0) {
          const facility = options.find((item: any) => item.facilityID === rowDetails?.sageFacilityIDForAccounting);
          if (facility) {
            setSageFacilityName(facility.facilityName);
          }
        }
      },
      (err: any) => toast.error(err)
    );
  };

  const getDisposalList = (assetID: any) => {
    const payload = {
      assetID: assetID
    };
    depreciationApi.GetDisposalList(
      payload,
      (resp: any) => {
        if (resp?.disposalList && resp.disposalList.length > 0) {
          setDisposalData(resp.disposalList[0]);
        } else {
          setDisposalData(null);
        }
      },
      (error: any) => {
        console.log("Error fetching disposal data:", error);
        setDisposalData(null);
      }
    );
  };

  const getAssetsList = (assetID: any) => {
    const payload = {
      assetID: assetID
    }
    assetsAPI.getAssetsList(payload, (data: any) => {
      setRowdetails(data.assetList[0]);

      const payload: any = {
        FacilityID: data.assetList[0]?.facilityID
      };


      facilityApi.getFacilityList(payload, (resp: any) => {
        setrowData(resp.facilityList ? resp.facilityList[0] : []);

      }, (error: any) => {

      });
    }, (error: any) => { });
  };

  useEffect(() => {
    if (params.id) {
      getAssetsList(params.id);
      getDisposalList(params.id);
    }
  }, [params, reloadKey]);

  useEffect(() => {
    if (rowDetails?.sageFacilityIDForAccounting) {
      getAllSageFacilities();
    }
  }, [rowDetails?.sageFacilityIDForAccounting]);
  return (
    <div className={`flex`}>
      <div className='flex-grow border-r border-gray-200 pt-4'>
        <div className='grid grid-cols-1 gap-6'>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Asset Information</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Asset ID</div></div>
              <div className='w-3/4 text-[#323233]'>

                {rowDetails?.assetCode ? rowDetails?.assetCode : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Description</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {rowDetails?.assetDescription ? rowDetails?.assetDescription : '-'}

              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Facility</div> </div>
              <div className='w-3/4 text-[#323233]'>

                {rowDetails?.facilityName ? rowDetails?.facilityName : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Sub Facility</div> </div>
              <div className='w-3/4 text-[#323233]'>

                {rowDetails?.subFacilityName ? rowDetails?.subFacilityName : '-'}
              </div>
            </div>

          </div>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Asset Group Information</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Ownership Type  </div></div>
              <div className='w-3/4 text-[#323233]'>{rowDetails?.groupName ? rowDetails?.groupName : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Asset Group </div></div>
              <div className='w-3/4 text-[#323233]'>{rowDetails?.assetSubGroupName ? rowDetails?.assetSubGroupName : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Asset Sage Facility </div></div>
              <div className='w-3/4 text-[#323233]'>{sageFacilityName}</div>
            </div>
            {/*
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Asset Type </div></div>
              <div className='w-3/4 text-[#323233]'>{rowDetails?.assetTypeName ? rowDetails?.assetTypeName : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Asset Classification </div></div>
              <div className='w-3/4 text-[#323233]'>{rowDetails?.assetClassificationName ? rowDetails?.assetClassificationName : '-'}</div>
            </div>            
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Category </div></div>
              <div className='w-3/4 text-[#323233]'>

                {rowDetails?.categoryName ? rowDetails?.categoryName : '-'}
              </div>
            </div>
            */}
          </div>
        </div>

        <div className='grid grid-cols-1 gap-6 mt-6'>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Asset Identity</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Manufacturer</div></div>
              <div className='w-3/4 text-[#323233]'>
                {rowDetails?.manufacturer ? rowDetails?.manufacturer : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Model Name</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {rowDetails?.modelName ? rowDetails?.modelName : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Part Number</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {rowDetails?.partNumber ? rowDetails?.partNumber : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Registration Number</div> </div>
              <div className='w-3/4 text-[#323233]'>

                {rowDetails?.registrationNumber ? rowDetails?.registrationNumber : '-'}
              </div>
            </div>

          </div>
          {/* {(rowDetails?.vinNumber || rowDetails?.vehicleTitleNumber || rowDetails?.vehicleTitleCountyID || rowDetails?.vehicleRegistrationNumber || rowDetails?.vehicleLastInspection) && ( */}
          {rowDetails?.assetCategoryID == 4 && (
            <div className={rowDetails?.assetCategoryID != 4 ? 'bg-gray-300 pl-5' : ''}>
              <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Vehicle</h4>
              <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Vin Number <span className='text-red-500'>*</span> </div></div>
                <div className='w-3/4 text-[#323233]'>
                  {rowDetails?.vinNumber ? rowDetails?.vinNumber : '-'}
                </div>
              </div>
              <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Title Number <span className='text-red-500'>*</span> </div></div>
                <div className='w-3/4 text-[#323233]'>
                  {rowDetails?.vehicleTitleNumber ? rowDetails?.vehicleTitleNumber : '-'}

                </div>
              </div>
              <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Title County <span className='text-red-500'>*</span> </div></div>
                <div className='w-3/4 text-[#323233]'>
                  {rowDetails?.vehicleTitleCountyID ? rowDetails?.vehicleTitleCountyID : '-'}
                </div>
              </div>
              <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Registration Number <span className='text-red-500'>*</span> </div></div>
                <div className='w-3/4 text-[#323233]'>
                  {rowDetails?.vehicleRegistrationNumber ? rowDetails?.vehicleRegistrationNumber : '-'}

                </div>
              </div>
              <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
                <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Inspection</div></div>
                <div className='w-3/4 text-[#323233]'>{rowDetails?.vehicleLastInspection ? moment(rowDetails?.vehicleLastInspection).format(DATE_FORMAT) : '-'}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='w-[19.5rem] p-[1.125rem] flex-grow-0 flex-shrink-0 '>
        <div className='max-w-[17.125rem] m-auto sticky top-[18px]'>
          <img className='border border-gray-200 rounded-md' src={rowDetails?.imageFullPath} alt="" />
          <h4 className='font-semibold text-[0.938rem] pt-5 pb-2'>Location</h4>
          <p className='text-[0.938rem] text-[#323233]'>{rowData?.addressLine1 ? rowData?.addressLine1 : '-'} </p>
          {/* <img className='mt-2' src={mapImg} alt="" /> */}

          {/* <LoadScript googleMapsApiKey={MAP_KEY}> */} {/* Replace with your API key */}

          {/* {isLoaded && <GoogleMap
            mapContainerStyle={{
              width: '100%',
              height: '200px',
            }}
            center={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }}
            zoom={15} // Adjust zoom level as needed
            mapTypeId="satellite"
          >

            <Marker position={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }} />
          </GoogleMap>} */}
          <iframe width="100%" height="250"
            style={{
              border: 0
            }} src={`https://maps.google.com/maps?width=100%&height=250&hl=en&coord=${rowData?.latitude ?? defaultLatitude}, ${rowData?.longitude ?? defaultLongitude}&q=${rowData?.latitude ?? defaultLatitude}, ${rowData?.longitude ?? defaultLongitude}&ie=UTF8&t=&z=14&iwloc=B&output=embed&t=k`}>
          </iframe>



          {/* </LoadScript> */}
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'> Department </div> </div>
            <div className='w-3/4 text-[#323233]'>   {rowDetails?.departmentName ? rowDetails?.departmentName : '-'}
            </div>
          </div>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Current Status</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {rowDetails?.statusName ? rowDetails?.statusName : '-'}
            </div>
          </div>
          <h4 className='font-semibold text-[0.938rem] pt-8 pb-0'>Purchase Information</h4>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Purchase Date </div> </div>
            {/* <div className='w-3/4 text-[#323233]'>{rowDetails?.purchaseDate ? showDate(rowDetails?.purchaseDate) : '-'}</div> */}
            <div className='w-3/4 text-[#323233]'>{rowDetails?.purchaseDate ? moment(rowDetails.purchaseDate, 'YYYY-MM-DD HH:mm:ss').format(DATE_FORMAT) : '-'}</div>
          </div>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Purchase Cost</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {rowDetails?.purchaseCost ? (
                <Currency currency="USD" value={rowDetails.purchaseCost} />
              ) : '-'}
            </div>
          </div>
          {(rowDetails?.groupName ==='Leased Assets' && rowDetails?.statusID == 7) && <><h4 className='font-semibold text-[0.938rem] pt-8 pb-0'>Disposal Information</h4>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Disposal Date </div> </div>
            <div className='w-3/4 text-[#323233]'>{disposalData?.disposalDate ? moment(disposalData.disposalDate).format(DATE_FORMAT) : '-'}</div>
          </div>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Disposal Type</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {disposalData?.disposalTypeName ? disposalData?.disposalTypeName : '-'}
            </div>
          </div>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Added By</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {disposalData?.addedByName ? disposalData?.addedByName : '-'}
            </div>
          </div>
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Added Date</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {disposalData?.addedDate ? moment(disposalData.addedDate).format(DATE_FORMAT) : '-'}
            </div>
          </div></>}
        </div>
      </div>
    </div>
  );
};

export default General;